import { Box } from '@mui/material';
import ChangePasswordForm from 'src/widgets/ChangePassword';
import { DesktopLayout, WithoutHeader } from 'src/layout';
import Title from 'src/components/Title';
import useIsMobileSize from 'src/hooks/useIsMobileSize';

export default function ChangePassword() {
    const mobile = useIsMobileSize();
    const content = (
        <Box sx={{ maxWidth: 600, py: 2 }}>
            <Box mb={3}>
                <Title>Изменение пароля</Title>
            </Box>
            <ChangePasswordForm />
        </Box>
    );
    return mobile ? (
        <WithoutHeader showBack>{content}</WithoutHeader>
    ) : (
        <DesktopLayout hideRightSidebar>{content}</DesktopLayout>
    );
}
